import { render, staticRenderFns } from "wisaapp-webstudent/src/components/mijn-gegevens/mijn-gegevens.html?vue&type=template&id=600ca8d7&"
import script from "wisaapp-webstudent/src/components/mijn-gegevens/mijn-gegevens.js?vue&type=script&lang=js&"
export * from "wisaapp-webstudent/src/components/mijn-gegevens/mijn-gegevens.js?vue&type=script&lang=js&"
import style0 from "wisaapp-webstudent/src/components/mijn-gegevens/mijn-gegevens.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports